import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "../contexts/AdminAuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { KeyRound, ShieldAlert } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAdminAuth();
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(code);
      toast.success("Connexion administrateur réussie");
      navigate("/admin/panel");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Code invalide");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-6"
      style={{ background: "linear-gradient(135deg, #121212 0%, #1a1a1a 100%)" }}
    >
      <form onSubmit={submit} className="w-full max-w-sm bg-[#1f1f1f] border border-[#FCD116]/20 rounded-2xl p-8 shadow-2xl" data-testid="admin-login-form">
        <div className="w-14 h-14 rounded-xl bg-[#FCD116]/10 border border-[#FCD116]/40 flex items-center justify-center mb-5 mx-auto">
          <ShieldAlert className="w-7 h-7 text-[#FCD116]" />
        </div>
        <h1 className="font-display text-2xl font-extrabold text-white text-center">Espace Propriétaire</h1>
        <p className="text-white/55 text-sm text-center mt-2 mb-6">
          Accès super-administrateur de la plateforme
        </p>

        <div className="space-y-1.5">
          <Label className="text-white/70">Code maître</Label>
          <div className="relative">
            <KeyRound className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/40" />
            <Input
              type="password"
              required
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="••••••••••••"
              className="pl-9 h-11 bg-white/5 border-white/15 text-white placeholder:text-white/30"
              data-testid="admin-code-input"
              autoFocus
            />
          </div>
        </div>

        <Button
          type="submit"
          disabled={loading}
          className="w-full mt-6 bg-[#FCD116] hover:bg-[#E8BC0F] text-[#121212] font-semibold h-11"
          data-testid="admin-login-btn"
        >
          {loading ? "Connexion…" : "Accéder au panel"}
        </Button>

        <p className="text-[10px] text-white/40 text-center mt-6 tracking-wide">
          Accès strictement réservé à l'éditeur de la plateforme.
        </p>
      </form>
    </div>
  );
}
